import React, { useState } from 'react';
import { FaUser, FaBriefcase, FaMapMarkerAlt, FaPhoneAlt, FaHome } from 'react-icons/fa';
import Select from 'react-select';
import Navbar from './Navbar';
import Fotter from './Fotter';

const initialSpecializations = [
  { value: 'Cardiologist', label: 'Cardiologist' },
  { value: 'Pediatrician', label: 'Pediatrician' },
  { value: 'Dermatologist', label: 'Dermatologist' },
  { value: 'Neurologist', label: 'Neurologist' },
  { value: 'Orthopedic Surgeon', label: 'Orthopedic Surgeon' },
  { value: 'Ophthalmologist', label: 'Ophthalmologist' },
  { value: 'ENT Specialist', label: 'ENT Specialist' },
  { value: 'Psychiatrist', label: 'Psychiatrist' },
  { value: 'Radiologist', label: 'Radiologist' },
  { value: 'Anesthesiologist', label: 'Anesthesiologist' },
];

const DoctorProfileForm = () => {
  const [formData, setFormData] = useState({
    doctorName: '',
    doctorSpecializations: [],
    homeAddress: '',
    clinicAddress: '',
    city: '',
    state: '',
    pincode: '',
    country: '',
    clinicNumber: '',
  });
  const [inputValue, setInputValue] = useState('');
  const [specializationOptions, setSpecializationOptions] = useState(initialSpecializations);

  const formContainerStyle = {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '30px',
    backgroundColor: '#f9f9f9',
    borderRadius: '12px',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
    fontFamily: 'sans-serif',
  };

  const formGroupStyle = {
    marginBottom: '25px',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '8px',
    fontWeight: 'bold',
    color: '#333',
  };

  const inputGroupStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  };

  const inputStyle = {
    flex: '1',
    padding: '12px 15px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '16px',
    color: '#555',
  };

  const iconStyle = {
    position: 'absolute',
    left: '15px',
    color: '#999',
    fontSize: '1.2em',
  };

  const inputWithIconPadding = {
    paddingLeft: '40px',
  };

  const buttonStyle = {
    backgroundColor: '#007bff',
    color: 'white',
    padding: '12px 20px',
    border: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3',
  };

  const selectStyles = {
    container: (provided) => ({
      ...provided,
      marginBottom: '25px',
    }),
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? '2px solid #007bff' : '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '16px',
      color: '#555',
      padding: '8px 15px',
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : null,
      '&:hover': {
        borderColor: '#007bff',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
    }),
    input: (provided) => ({
      ...provided,
      color: '#555',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '16px',
      color: '#999',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '16px',
      color: '#333',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#bbe1fa',
      borderRadius: '5px',
      color: '#333',
      display: 'flex',
      alignItems: 'center',
      marginRight: '5px',
      marginBottom: '2px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#333',
      padding: '2px 5px',
      fontSize: '14px',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      cursor: 'pointer',
      color: '#999',
      '&:hover': {
        backgroundColor: '#e0f2f7',
        color: '#333',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#e0f2f7' : null,
      color: state.isSelected ? 'white' : '#333',
      fontSize: '16px',
      padding: '10px 15px',
      '&:hover': {
        backgroundColor: '#d9edf7',
        color: '#333',
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'white',
      zIndex: 1,
    }),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSpecializationChange = (selectedOptions) => {
    setFormData(prevState => ({
      ...prevState,
      doctorSpecializations: selectedOptions,
    }));
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    return newValue;
  };

  const handleCreateOption = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    if (inputValue && !formData.doctorSpecializations.some(option => option.value === inputValue)) {
      setFormData(prevState => ({
        ...prevState,
        doctorSpecializations: [...prevState.doctorSpecializations, newOption],
      }));
      setSpecializationOptions([...specializationOptions, newOption]);
      setInputValue('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data Submitted:', formData);
    alert('Profile data submitted!');
  };

  const addressRowStyle = {
    display: 'flex',
    gap: '20px',
    marginBottom: '25px',
  };

  const addressColumnStyle = {
    flex: '1', // Distribute available space equally
  };

  return (
    <>
    <Navbar/><br/><br/><br/><br/><br/><br/><br/>
    <div style={formContainerStyle}>
      <h2 style={{ textAlign: 'center', color: '#283593', marginBottom: '30px' }}>
        Complete Your Doctor Profile
      </h2>
      <form onSubmit={handleSubmit}>
        <div style={formGroupStyle}>
          <label htmlFor="doctorName" style={labelStyle}>
            <FaUser style={{ marginRight: '8px' }} /> Doctor Name
          </label>
          <div style={inputGroupStyle}>
            <FaUser style={iconStyle} />
            <input
              type="text"
              id="doctorName"
              name="doctorName"
              value={formData.doctorName}
              onChange={handleChange}
              style={{ ...inputStyle, ...inputWithIconPadding }}
              placeholder="Enter your full name"
              required
            />
          </div>
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="doctorSpecializations" style={labelStyle}>
            <FaBriefcase style={{ marginRight: '8px' }} /> Specialization(s)
          </label>
          <Select
            isMulti
            name="doctorSpecializations"
            value={formData.doctorSpecializations}
            onChange={handleSpecializationChange}
            options={specializationOptions}
            placeholder="Select or type specializations"
            isSearchable
            onCreateOption={handleCreateOption}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            styles={selectStyles} // Apply the inline styles here
          />
          <p style={{ fontSize: '0.9em', color: '#777' }}>
            You can select from the dropdown or type to add new specializations. Press Enter to add.
          </p>
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="homeAddress" style={labelStyle}>
            <FaHome style={{ marginRight: '8px' }} /> Home Address
          </label>
          <div style={inputGroupStyle}>
            <FaHome style={iconStyle} />
            <input
              type="text"
              id="homeAddress"
              name="homeAddress"
              value={formData.homeAddress}
              onChange={handleChange}
              style={{ ...inputStyle, ...inputWithIconPadding }}
              placeholder="Enter your home address"
            />
          </div>
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="clinicAddress" style={labelStyle}>
            <FaMapMarkerAlt style={{ marginRight: '8px' }} /> Clinic Address
          </label>
          <div style={inputGroupStyle}>
            <FaMapMarkerAlt style={iconStyle} />
            <input
              type="text"
              id="clinicAddress"
              name="clinicAddress"
              value={formData.clinicAddress}
              onChange={handleChange}
              style={{ ...inputStyle, ...inputWithIconPadding }}
              placeholder="Enter your clinic's full address"
              required
            />
          </div>
        </div>

        <div style={addressRowStyle}>
          <div style={addressColumnStyle}>
            <label htmlFor="country" style={labelStyle}>Country</label>
            <input
              type="text"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter country"
            />
          </div>
          <div style={addressColumnStyle}>
            <label htmlFor="city" style={labelStyle}>City</label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter city"
            />
          </div>
        </div>

        <div style={addressRowStyle}>
          <div style={addressColumnStyle}>
            <label htmlFor="state" style={labelStyle}>State</label>
            <input
              type="text"
              id="state"
              name="state"
              value={formData.state}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter state"
            />
          </div>
          <div style={addressColumnStyle}>
            <label htmlFor="pincode" style={labelStyle}>Pincode</label>
            <input
              type="text"
              id="pincode"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter pincode"
            />
          </div>
        </div>

        <div style={formGroupStyle}>
          <label htmlFor="clinicNumber" style={labelStyle}>
            <FaPhoneAlt style={{ marginRight: '8px' }} /> Clinic Number
          </label>
          <div style={inputGroupStyle}>
            <FaPhoneAlt style={iconStyle} />
            <input
              type="tel"
              id="clinicNumber"
              name="clinicNumber"
              value={formData.clinicNumber}
              onChange={handleChange}
              style={{ ...inputStyle, ...inputWithIconPadding }}
              placeholder="Enter your clinic's phone number"
              required
            />
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <button type="submit" style={buttonStyle} onMouseOver={(e) => Object.assign(e.target.style, buttonHoverStyle)} onMouseOut={(e) => Object.assign(e.target.style, buttonStyle)}>
            Submit Profile
          </button>
        </div>
      </form>
    </div>
    <Fotter/>
    </>
  );
};

export default DoctorProfileForm;